import {
  UseInfiniteQueryOptions,
  UseQueryOptions,
  useInfiniteQuery,
  useQuery,
} from '@tanstack/react-query';
import { graphqlApi } from '@configs/axios-instances';

export interface UseGraphqlProps extends UseQueryOptions {
  graphqlQuery: string;
  variables?: object;
}

export const useGraphql = ({ graphqlQuery, variables, ...props }: UseGraphqlProps) => {
  return useQuery({
    ...props,
    queryFn: async () => graphqlApi.post('', { query: graphqlQuery, variables }),
  });
};

interface UseInfiniteGraphqlProps extends UseInfiniteQueryOptions {
  graphqlQuery: string;
  variables?: object;
}

export const useInfiniteGraphql = ({
  graphqlQuery,
  variables,
  ...props
}: UseInfiniteGraphqlProps) => {
  return useInfiniteQuery({
    ...props,
    queryFn: async ({ pageParam = '1' }) => {
      return graphqlApi.post('', {
        query: graphqlQuery,
        variables: { ...variables, pageNo: pageParam },
      });
    },
  });
};
